module.exports = __webpack_public_path__ + "static/img/payford.636a4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-img/payford.png
// module id = 993
// module chunks = 173